export default {
	'daily-journal': 'Yövmiye özeti',
	'sales-refunds': 'satışlar / iadeler',
	'purchase-refunds': 'Satın alınanlar / iadeler',
	'in-out-cashbox': 'kasadan alınanlar / ödenenler',
	total: 'Toplam',
	'cash-total': 'Toplam nakit',
	'card-total': 'toplam kart',
	'unposted-amount': 'Gönderilmemiş tutar',
}